<div id="donut" style="max-width: 380px;">
    <apx-chart
        [series]="chartOptions.series"
        [chart]="chartOptions.chart"
        [labels]="chartOptions.labels"
        [responsive]="chartOptions.responsive"
        [colors]="donutColors"
    ></apx-chart>
</div>